import { useRecoilValue } from "recoil";
import { altitudeState } from "../../../store/MapAltitudeState";
import useEffectSkipFirst from "../../../hooks/useEffectSkipFirst";
import { useMemo } from "react";

function WxRangeAltDispatcher({contents}) {
  const altitude = useRecoilValue(altitudeState);
  const dependency = useMemo(() => ([altitude]), [altitude]);

  useEffectSkipFirst(() => {
    contents.applyAltitude && contents.applyAltitude(altitude);
  }, dependency);

  //dont draw anything
  return null;
}
export default WxRangeAltDispatcher;